import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import toast from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const useDeleteConfiguracaoAssinatura = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["config-assinatura-digital"]);
    toast.success("Configuração de assinatura digital excluída com sucesso.");
  };

  const onError = () => {
    toast.error("Erro ao excluir a configuração de assinatura!");
  };

  return useDelete<number>({
    url: api.groupsign.configuracaoDocumentoAssinaturaDigital,
    onSuccess,
    onError
  })
};
